import React from 'react';
import GameModal from '../../components/GameModal/GameModal.tsx';
import { RANK_LEVELS, getCurrentRank, getThresholdScore } from './progressLevels.ts';

interface SubtextRankingsModalProps {
  score: number;
  realisticMaxScore: number;
  isOpen: boolean;
  onClose: () => void;
}

export default function SubtextRankingsModal({ score, realisticMaxScore, isOpen, onClose }: SubtextRankingsModalProps) {
  if (!isOpen) return null;

  const currentRank = getCurrentRank(score, realisticMaxScore);

  const modalContent = (
    <div className="rankings-modal-content">
      <div className="rankings-description">
        Ranks are based on a percentage of possible points in a puzzle.
      </div>

      <table className="rankings-table">
        <thead>
          <tr className="rankings-header">
            <th className="rank-marker-header"></th>
            <th className="rank-title-header">Rank</th>
            <th className="rank-spacer-header"></th>
            <th className="rank-points-header">Minimum score</th>
          </tr>
        </thead>
        <tbody>
          {RANK_LEVELS.slice().reverse().map((rank, index) => {
            const thresholdScore = getThresholdScore(rank, realisticMaxScore);
            const isActive = score >= thresholdScore;
            const isCurrent = rank.id === currentRank.id;
            const isFirst = index === 0;
            const isLast = index === RANK_LEVELS.length - 1;
            
            return (
              <tr 
                key={rank.name} 
                className={`ranking-row ${isCurrent ? 'current-ranking' : ''} ${isActive ? 'achieved' : ''}`}
              >
                <td className="rank-marker">
                  {!isFirst && (
                    <div 
                      className={`rank-line rank-line-top ${isActive ? 'active' : ''}`}
                    />
                  )}
                  <div 
                    className={`rank-dot ${isActive ? 'active' : ''} ${isCurrent ? 'current' : ''}`}
                  >
                    {isCurrent && (
                      <span className="current-score-display">{score}</span>
                    )}
                  </div>
                  {!isLast && (
                    <div 
                      className={`rank-line rank-line-bottom ${isActive ? 'active' : ''}`}
                    />
                  )}
                </td>
                <td className="rank-name">{rank.name}</td>
                <td className="rank-spacer">
                  <div className="spacer-line"></div>
                </td>
                <td className="rank-score">{thresholdScore}</td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );

  const titleStyle: React.CSSProperties = {
    fontSize: '24px',
    fontWeight: '700',
  };

  return (
    <GameModal
      title="Rankings"
      titleStyle={titleStyle}
      content={modalContent}
      isOpen={isOpen}
      onClose={onClose}
    />
  );
} 